var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('canvas',{ref:"canvas"}),(_vm.timerPercent!=1)?_c('div',{ref:"time",staticClass:"time",style:(_vm.timeStyles)},[_vm._v(_vm._s(_vm.textDuration))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }